import { PayPalNVP } from 'src/pages/paypalnvp/paypal-nvp';
import { EXTERNAL_URLS, CUSTOMER_SERVICE_PHONE, CUSTOMER_SERVICE_HOURS_MOBILE, CUSTOMER_SERVICE_HOURS_DESKTOP } from 'src/constants/param-constants';

import { AfterViewInit, Component, HostListener, NgZone, OnDestroy, OnInit } from '@angular/core';
import { PlatformLocation, CurrencyPipe } from '@angular/common'
import { DomSanitizer } from '@angular/platform-browser';
import { NgForm, FormControl } from '@angular/forms';
import { Storage } from '@ionic/storage-angular';
import { Router } from '@angular/router';


import { ToastController } from 'src/app/components/ionic-replacements/ToastController';
import { NavControllerExt } from 'src/app/extensions/nav-controller-extension';
import { OrderProviderExtender } from '../../../providers/order/order-extender';
import { TouchcrApiOrderformProvider } from '../../../providers/touchcr-api-orderform/touchcr-api-orderform';
import { CartProvider } from '../../../providers/cart/cart';
import { TouchcrApiRemoteServicesProvider } from 'src/app/providers/touchcr-api-remoteservices';
import { TouchcrApiLeadProvider } from '../../../providers/touchcr-api-lead/touchcr-api-lead';
import { TouchcrApiCouponProvider } from '../../../providers/touchcr-api-coupon/touchcr-api-coupon';
import { OrderDetailsProvider } from '../../../providers/order-details/order-details';
import { TouchcrApiShippingProvider } from '../../../providers/TouchcrApiShippingProvider';
import { CalculateProvider } from '../../../providers/calculate/calculate';
import { UrlsProvider } from 'src/app/providers/urls';
import { OrderProvider } from 'src/app/providers/order/order';
import { GeneralProvider } from 'src/app/providers/general';
import { LoggingProvider } from 'src/app/providers/logging';
import { SpinnerProvider } from '../../../providers/spinner/spinner';
import { TouchcrApiGeneralExtenderProvider } from '../../../providers/touchcr-api-general/touchcr-api-general-extender';
import { TouchcrApiOrderExtenderProvider } from '../../../providers/touchcr-api-order/touchcr-api-order-extender';
import { EventStreamerProvider } from 'src/app/providers/event-stream';
import { PaypalPaymentExtenderProvider } from '../../../providers/paypal/paypal-extender';
import { StateProvider } from 'src/app/providers/state';
import { FunnelSettingsProvider } from 'src/app/providers/funnel-settings';
import { Country } from '../../../models/country';
import { CHECKOUT_LABEL, PAYMENT_LABEL, SHIPPING_LABEL } from 'src/constants/constants';
import { DynamicCurrencyPipe } from 'src/app/shared/pipes/dynamic-currency.pipe';
import { CheckoutCommon } from '../../_brand-pages-base/base-controllers/checkout/checkout-common';
@Component({
  selector: 'checkout-common-v2',
  templateUrl: './checkout-common-v2.html',
  styleUrls: ['./checkout-common-v2.scss']
})
export class CheckoutCommonV2 extends CheckoutCommon {
  override iconPaypal: string = EXTERNAL_URLS.PAYPAL_BUTTON;
  public override twoNameShipping: boolean = true;
  public customerServicePhone: string = CUSTOMER_SERVICE_PHONE;
  public customerServiceHours_Mobile: string = CUSTOMER_SERVICE_HOURS_MOBILE;
  public customerServiceHours_Desktop: string = CUSTOMER_SERVICE_HOURS_DESKTOP;
  constructor(
    public override navCtrl: NavControllerExt,
    public override sanitizer: DomSanitizer,
    public override tcrApiOrderform: TouchcrApiOrderformProvider,
    public override cart: CartProvider,
    public override tcrApi: TouchcrApiGeneralExtenderProvider,
    public override tcrApiOrder: TouchcrApiOrderExtenderProvider,
    public override tcrApiRemoteServices: TouchcrApiRemoteServicesProvider,
    public override toastCtrl: ToastController,
    public override eventStreamer: EventStreamerProvider,
    public override tcrApiLead: TouchcrApiLeadProvider,
    public override tcrApiCoupon: TouchcrApiCouponProvider,
    public override orderDetails: OrderDetailsProvider,
    public override paypalPayment: PaypalPaymentExtenderProvider,
    public override ngZone: NgZone,
    public override shippingProvider: TouchcrApiShippingProvider,
    public override calculateHelper: CalculateProvider,
    public override urlsHelper: UrlsProvider,
    public override orderHelper: OrderProvider,
    public override orderHelperExtender: OrderProviderExtender,
    public override stateProvider: StateProvider,
    public override general: GeneralProvider,
    public override funnelProvider: FunnelSettingsProvider,
    public override spinner: SpinnerProvider,
    public override location: PlatformLocation,
    public override loggingProvider: LoggingProvider,
    public override currencyPipe: CurrencyPipe,
    public override router: Router,
    public override dynamicCurrencyPipe: DynamicCurrencyPipe,
    public override storage?: Storage
  ) {
    super(
      navCtrl,
      sanitizer,
      tcrApiOrderform,
      cart,
      tcrApi,
      tcrApiOrder,
      tcrApiRemoteServices,
      toastCtrl,
      eventStreamer,
      tcrApiLead,
      tcrApiCoupon,
      orderDetails,
      paypalPayment,
      ngZone,
      shippingProvider,
      calculateHelper,
      urlsHelper,
      orderHelper,
      orderHelperExtender,
      stateProvider,
      general,
      funnelProvider,
      spinner,
      location,
      loggingProvider,
      currencyPipe,
      router,
      dynamicCurrencyPipe,
      storage
    );
  }

  //Use this method to set up initial values for template variables
  override populatePageData() {
    let body = document.getElementsByTagName('body')[0];
    body.setAttribute('data-qa', 'checkout-page');
    this.brandLogo = '/assets/img/drivenEntrepreneur-logo.png';
  }

  getTotalInstallments(): number {
    if (this.currentFunnel?.totalInstallments) {
      return this.currentFunnel.totalInstallments;
    }
    
    if (this.currentFunnel?.orderFormBrand?.defaultInstallmentCount) {
      return this.currentFunnel.orderFormBrand.defaultInstallmentCount;
    }
    
    return 0;
  }

  getInitialInstallmentAmount(): number {
    if (this.currentFunnel?.initialInstallmentAmount) {
      return this.currentFunnel.initialInstallmentAmount;
    }
    
    const totalInstallments = this.getTotalInstallments();
    if (this.currentFunnel?.offerPrice && totalInstallments > 0) {
      return this.currentFunnel.offerPrice / totalInstallments;
    }
    
    return 0;
  }

} 